import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { IconComponent } from '@lite-workspace/shared/blocks/icon';
import { ThemeService } from '@lite-workspace/shared/theme';
import { cva, type VariantProps } from 'class-variance-authority';

// compact = the editor top-bar icon row's anatomy, the same box as the undo/redo buttons beside it.
const themeToggleVariants = cva('grid place-items-center', {
  variants: {
    size: {
      md: 'size-7 rounded-md text-c2 hover:bg-panel2 hover:text-ink',
      compact: 'size-7.5 rounded-[var(--r-button)] text-ink hover:bg-panel2 disabled:opacity-40',
    },
  },
  defaultVariants: { size: 'md' },
});

type ThemeToggleSize = NonNullable<VariantProps<typeof themeToggleVariants>['size']>;

@Component({
  selector: 'app-theme-toggle',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <button
      type="button"
      [class]="buttonClass()"
      [attr.aria-label]="isDark() ? 'Включить светлую тему' : 'Включить тёмную тему'"
      [attr.aria-pressed]="isDark()"
      (click)="theme.toggle()"
    >
      <app-icon [name]="isDark() ? 'sun' : 'moon'" [size]="17" />
    </button>
  `,
})
export class ThemeToggleComponent {
  protected readonly theme = inject(ThemeService);

  readonly size = input<ThemeToggleSize>('md');

  protected readonly buttonClass = computed(() => themeToggleVariants({ size: this.size() }));
  protected readonly isDark = computed(() => this.theme.resolvedTheme() === 'dark');
}
